import client from "../api/client";
export const getList = () => {
  return client('/api/countries').then(({ data }) => data.data);
};

export function useCountryService () {
  return {
    getList,
  };
}
